import { FieldConfiguration } from '../../../api/ConfigApi';
import { FormBuilder, FormShape } from '../types';
import filterObjectByKeys from './filterObjectByKeys';

const flattenFormBuilderToArray = (form: FormShape<FormBuilder>) => {
	const flatForm = Object.keys(form).reduce((acc, key) => {
		const currLevelForm = form[key] as FormShape<FormBuilder>;
		const newFields = [...currLevelForm.fields] as FieldConfiguration[];
		const filteredForm = filterObjectByKeys(currLevelForm);
		if (Object.keys(filteredForm).length > 0) {
			const nestedForms = flattenFormBuilderToArray(filteredForm);
			newFields.push(...nestedForms);
		}
		return [
			...acc,
			...newFields.map((field) => ({ ...field, name: `${key}.${field.name}` })),
		];
	}, [] as FieldConfiguration[]);
	return flatForm;
};

export default flattenFormBuilderToArray;
